import CustomError from './CustomError'

export default class InvalidBusinessProfileRequestedError extends CustomError {
  constructor(message: string) {
    super(message)
  }
}
